!function (e, _) {
  "object" == typeof exports && "undefined" != typeof module ? module.exports = _(require("dayjs")) : "function" == typeof define && define.amd ? define(["dayjs"], _) : (e = "undefined" != typeof globalThis ? globalThis : e || self).dayjs_locale_bn = _(e.dayjs);
}(this, function (e) {
  "use strict";

  function _(e) {
    return e && "object" == typeof e && "default" in e ? e : {
      default: e
    };
  }

  var t = _(e),
      n = {
    1: "১",
    2: "২",
    3: "৩",
    4: "৪",
    5: "৫",
    6: "৬",
    7: "৭",
    8: "৮",
    9: "৯",
    0: "০"
  },
      d = {
    "১": "1",
    "২": "2",
    "৩": "3",
    "৪": "4",
    "৫": "5",
    "৬": "6",
    "৭": "7",
    "৮": "8",
    "৯": "9",
    "০": "0"
  },
      o = {
    name: "bn",
    weekdays: "রবিবার_সোমবার_মঙ্গলবার_বুধবার_বৃহস্পতিবার_শুক্রবার_শনিবার".split("_"),
    months: "জানুয়ারি_ফেব্রুয়ারি_মার্চ_এপ্রিল_মে_জুন_জুলাই_আগস্ট_সেপ্টেম্বর_অক্টোবর_নভেম্বর_ডিসেম্বর".split("_"),
    weekdaysShort: "রবি_সোম_মঙ্গল_বুধ_বৃহস্পতি_শুক্র_শনি".split("_"),
    monthsShort: "জানু_ফেব্রু_মার্চ_এপ্রিল_মে_জুন_জুলাই_আগস্ট_সেপ্ট_অক্টো_নভে_ডিসে".split("_"),
    weekdaysMin: "রবি_সোম_মঙ্গ_বুধ_বৃহঃ_শুক্র_শনি".split("_"),
    preparse: function preparse(e) {
      return e.replace(/[১২৩৪৫৬৭৮৯০]/g, function (e) {
        return d[e];
      });
    },
    postformat: function postformat(e) {
      return e.replace(/\d/g, function (e) {
        return n[e];
      });
    },
    ordinal: function ordinal(e) {
      return e;
    },
    formats: {
      LT: "A h:mm সময়",
      LTS: "A h:mm:ss সময়",
      L: "DD/MM/YYYY",
      LL: "D MMMM YYYY",
      LLL: "D MMMM YYYY, A h:mm সময়",
      LLLL: "dddd, D MMMM YYYY, A h:mm সময়"
    },
    relativeTime: {
      future: "%s পরে",
      past: "%s আগে",
      s: "কয়েক সেকেন্ড",
      m: "এক মিনিট",
      mm: "%d মিনিট",
      h: "এক ঘন্টা",
      hh: "%d ঘন্টা",
      d: "এক দিন",
      dd: "%d দিন",
      M: "এক মাস",
      MM: "%d মাস",
      y: "এক বছর",
      yy: "%d বছর"
    }
  };

  return t.default.locale(o, null, !0), o;
});